import {useState} from 'react';

import WebsiteForm from '../../components/website-form';
import {
    accountRegistrationRequiresApproval,
    getApprovalReturnUrl,
    getRegistrationSignInHref
} from './registration-utils';

export const RouteLink = ({component: LinkComponent = 'a', href, ...props}) => (
    LinkComponent === 'a'
        ? <a href={href} {...props}/>
        : <LinkComponent to={href} {...props}/>
);

export default function RegistrationForm({from = '/', linkComponent, node, preview = false, ...props}) {
    const [awaitingApproval, setAwaitingApproval] = useState(false);
    const approvalReturnUrl = getApprovalReturnUrl(from);
    const returnLabel = approvalReturnUrl === '/' ? 'Return To Website' : 'Return To Previous Page';

    if (awaitingApproval) {
        return (
            <div role="status" className="text-center">
                <h3 className="!mb-3">Registration Received</h3>
                <p>
                    Thanks — your registration has been received. Your account needs to be approved before you can
                    sign in and continue.
                </p>
                <RouteLink component={linkComponent} className="button justify-center mt-6" href={approvalReturnUrl}>
                    {returnLabel}
                </RouteLink>
            </div>
        );
    }

    return (
        <div>
            <WebsiteForm
                {...props}
                node={node}
                label="Register"
                submitButtonClassName="w-full justify-center"
                preview={preview}
                onSubmitted={(submittedValues, submissionResult) => accountRegistrationRequiresApproval(
                    props?.values?.form,
                    submittedValues,
                    submissionResult
                )
                    ? setAwaitingApproval(true)
                    : window.location.replace(`${window.location.origin}${approvalReturnUrl}`)}
            />
            <p className="mt-4 text-center">
                Already have an account?{' '}
                <RouteLink
                    component={linkComponent}
                    href={getRegistrationSignInHref(approvalReturnUrl)}
                    aria-disabled={preview || undefined}
                    tabIndex={preview ? -1 : undefined}
                    onClick={preview ? event => event.preventDefault() : undefined}
                >
                    Sign In
                </RouteLink>
            </p>
        </div>
    );
}
